'use client';

import { apiClient } from '@borradh-workspace/api-client';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/query-keys';
import type { OptInConfig } from '../types';

export const getOptInConfigQueryOptions = (organizationSlug: string) =>
  queryOptions({
    queryKey: queryKeys.optIn.config(organizationSlug),
    queryFn: async () =>
      apiClient.get<OptInConfig>(`public/opt-in/${organizationSlug}`),
    enabled: !!organizationSlug,
    staleTime: 5 * 60 * 1000,
  });

export const useGetOptInConfig = (organizationSlug: string) => {
  const query = useQuery(getOptInConfigQueryOptions(organizationSlug));
  return {
    config: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
};
